//
import React from 'react';

const TableHeader = ({ headers }) => {
  return (
    <thead className="table-light text-center"   style={{
      position: "sticky",
      top: 0,
      
      zIndex: 1,
      // boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    }}>
      <tr>
        {headers.map((header, index) => (
          <th key={index} className="text-center">
            {header}
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default TableHeader;
